export default (message = '') => ({
	message,
	invalid: false,

	// METHODS
	reportValidity() {
		// Dispatch custom event to tie into.
		this.$refs.input.dispatchEvent(new CustomEvent('validation-update', { bubbles: true }));

		let { validity, validationMessage, dataset } = this.$refs.input;

		// Give execution time for the validationUpdate event listeners to fire.
		// Mark if the input is invalid.
		this.invalid = !validity.valid;

		// Check the input's data attributes for custom messages.
		for (let key in validity) {
			if (validity[key] && (key in dataset)) {
				this.message = dataset[key];
				return;
			}
		}

		// Fall back to the browser default message.
		this.message = validationMessage;
	},

	// ELEMENTS
	input: {
		'x-ref': 'input',
		'@blur': 'reportValidity',
		'@invalid.prevent': 'reportValidity',
		':style'() {
			return this.invalid ? {
				'border-color': 'red',
			} : '';
		},
		':aria-invalid'() {
			return !!this.message;
		},
	},
	error: {
		'role': 'status',
		'x-ref': 'error',
		'x-text'() {
			return this.message;
		},
		':style'() {
			return this.message ? {
				'display': 'block',
			} : '';
		},
	},
});
